import React from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Footer = (props) => {
  const { themeSettingsData } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const arr = [
    { id: 1, name: t('help'), path: '/help' },
    { id: 2, name: t('cookies'), path: '/Cookies' },
    { id: 3, name: t('contact'), path: '/contactus' },
    { id: 4, name: t('accessibility'), path: '/accessibility' },
    { id: 5, name: t('privacyPolicy'), path: '/privacypolicy' },
  ];
  return (
    <div className="mt-5" style={{ backgroundColor: themeSettingsData?.P_THEME?.P_FOOTER_REG_COLOR, borderTop: `12px solid ${themeSettingsData?.P_THEME?.P_SEP_REG_BG_COLOR}` }}>
      {themeSettingsData?.P_THEME ? (
        <div className="container-xxl footerBox">
          <div className="footerButtons">
            <div className="footer-link-container">
              {arr.map((d) => {
                return (
                  <a
                    href=""
                    className="govuk-link"
                    key={d.id}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`${d.path}`);
                    }}
                    style={{ color: themeSettingsData?.P_THEME?.P_FOOTER_REG_TEXT_COLOR, backgroundColor: themeSettingsData?.P_THEME?.P_FOOTER_REG_COLOR }}
                  >
                    {' '}
                    {d.name}
                  </a>
                );
              })}
            </div>
            <div className="">
              <span
                className="fw-bold me-1 text-wrap"
                style={{ color: themeSettingsData?.P_THEME?.P_FOOTER_REG_TEXT_COLOR, height: '44px' }}
                dangerouslySetInnerHTML={{ __html: themeSettingsData?.P_THEME?.P_FOOTER_TEXT }}
              />
            </div>
          </div>
          <div className="footerIcon">
            {themeSettingsData?.P_THEME?.P_FOOTER_LOGO ? (
              <div className="pt-4">
                <img
                  src={themeSettingsData?.P_THEME?.P_FOOTER_LOGO}
                  style={{
                    height:
                      themeSettingsData?.P_THEME?.P_FOOTER_LOGO_HEIGHT === 'auto'
                        ? `${themeSettingsData?.P_THEME?.P_FOOTER_LOGO_HEIGHT}`
                        : `${themeSettingsData?.P_THEME?.P_FOOTER_LOGO_HEIGHT}px`,
                    width:
                      themeSettingsData?.P_THEME?.P_FOOTER_LOGO_WIDTH === 'auto'
                        ? `${themeSettingsData?.P_THEME?.P_FOOTER_LOGO_WIDTH}`
                        : `${themeSettingsData?.P_THEME?.P_FOOTER_LOGO_WIDTH}px`,
                    objectFit: 'contain',
                  }}
                  alt="footerLogo"
                />
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
const mapStateToProps = ({ themeSlice }) => {
  const { themeSettingsData } = themeSlice;
  return { themeSettingsData };
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Footer);
